var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataLoaded)?_c('div',[_vm._l((this.treeData),function(aTreeData,index){return [_c('div',{key:index,staticClass:"box-wrapper",class:'pages'+(index+5)},[_c('TabContent',{key:`a_${index}_${aTreeData.titleName}`,attrs:{"node":aTreeData}})],1)]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }